import { useEffect, useState } from 'react';
import CreatableSelect from 'react-select/creatable';
import { toast } from 'react-toastify';
import { createProjectMeetingNoteTypes, getProjectMeetingNoteTypes } from '../api/meetingNotes';

export const MeetingNoteTypes = ({
  onChange,
  defaultValue,
  onCreate,
  token,
  onRefresh,
  hasError,
}: {
  onChange: (value: any) => void;
  onCreate: (value: any) => void;
  defaultValue: string;
  token: string | undefined;
  project_id: string;
  onRefresh?: number;
  hasError?: boolean;
}) => {
  const [isTypeLoading, setIsTypeLoading] = useState(false);
  const [typesOptions, setTypesOptions] = useState<any[]>([]);

  const loadMeetingTypes = async () => {
    if (!token) return;
    
    try {
      const data = await getProjectMeetingNoteTypes(token);
      setTypesOptions(data.results.map((p) => ({ label: p.name, value: p.id })));
    } catch (error) {
      console.error('Failed to load meeting types:', error);
    }
  };

  // Auto-select first option if nothing selected
  useEffect(() => {
    if (!defaultValue && typesOptions.length > 0) {
      onChange(typesOptions[0]);
    }
  }, [defaultValue, typesOptions, onChange]);

  useEffect(() => {
    loadMeetingTypes();
  }, [token, onRefresh]);

  const createTypeOption = (id: string, label: string) => ({
    label,
    value: id,
  });

  const handleCreateType = async (inputValue: string) => {
    setIsTypeLoading(true);
    const id = crypto.randomUUID();
    try {
      const res = await createProjectMeetingNoteTypes(token || '', {
        id,
        name: inputValue,
      });

      const newOption = createTypeOption(res.id, inputValue);
      setTypesOptions((prev) => [...prev, newOption]);
      onCreate(res.id);
    } catch (error) {
      toast.error('Failed to create meeting note type');
    }
    setIsTypeLoading(false);
  };

  return (
    <CreatableSelect
      isClearable
      isDisabled={isTypeLoading}
      isLoading={isTypeLoading}
      onChange={onChange}
      onCreateOption={handleCreateType}
      options={typesOptions}
      value={typesOptions.find((type) => type.value === defaultValue)}
      placeholder="Select..."
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          minHeight: '42px',
          borderColor: state.isFocused ? '#3B82F6' : hasError ? '#ef4444' : '#eaeaea',
          borderRadius: '8px',
          boxShadow: state.isFocused
            ? '0 0 0 2px rgba(59, 130, 246, 0.1)'
            : hasError
            ? '0 0 0 2px rgba(239, 68, 68, 0.1)'
            : 'none',
          '&:hover': {
            borderColor: state.isFocused ? '#3B82F6' : hasError ? '#ef4444' : '#ddd',
          },
        }),
        indicatorSeparator: () => ({ display: 'none' }),
        menu: (baseStyles) => ({
          ...baseStyles,
          zIndex: 9999,
        }),
      }}
    />
  )
}